import React from 'react';
import { gray60 } from "../../vars.js";

export const MinusCircle = ({ width = 16, height = 16, color = gray60, className = '' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={className}>
            <g clip-path="url(#clip0_324_30537)">
                <path d="M5.33301 7.99992H10.6663M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_324_30537">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>        
    );
};

export default MinusCircle;